import {TInvoiceConfigResponse} from '../../../coreGlobal/models/franchise/franchise'

export const buildUpdateInvoiceConfigRequest = (data: TInvoiceConfigResponse) => {
  return {
    invoice_due_day: data.invoiceDueDay,
    billing_period: data.billingPeriod,
  }
}
